import api from "plus/api";
import { throttle } from "lodash";

/**
 * NORMAL 通用模板：动态模块渲染、标签、关联工单、地区/机构等辅助逻辑
 */
export default {
  methods: {
    async getAreaTree() {
      const response = await api.common.getAreaTree();
      const fullTree = response.data.data;
      this.areaTree = fullTree;
      console.log("地区树", this.areaTree);
    },
    async getProjectTree() {
      if (this.projectLoading || this.projectTree.length > 0) return;
      this.projectLoading = true;
      try {
        const response = await api.common.getProjectTree();
        this.projectTree = this.formatProjectTree(response.data.data || []);
      } finally {
        this.projectLoading = false;
      }
    },
    formatProjectTree(list) {
      return list.map((item) => {
        const disabled = item.isEnable === false;
        const childs = Array.isArray(item.childs)
          ? this.formatProjectTree(item.childs)
          : [];
        const project = {
          ...item,
          disabled,
          displayName: `${item.name}（${disabled ? "禁用" : "启用"}）`,
        };
        if (childs.length > 0) {
          project.childs = childs;
        } else {
          delete project.childs;
        }
        return project;
      });
    },
    async getCompanyList(keyWord = "") {
      this.companyLoading = true;
      try {
        const response = await api.common.getCompanyList({
          page: 1,
          pageSize: 20,
          keyWord,
        });
        this.companyList = response.data.data;
      } finally {
        this.companyLoading = false;
      }
    },
    remoteCompanySearch: throttle(function (query) {
      this.getCompanyList(query);
    }, 500),
    onAccurateCompanyChange(val) {
      if (!val) {
        this.form.accurateCompanyInfo = {
          abbreviation: "",
          companyId: "",
          companyName: "",
        };
        return;
      }
      const selected = this.companyList.find((x) => x.hospitalId === val);
      if (selected) {
        this.form.accurateCompanyInfo = {
          abbreviation: selected.abbreviation || "",
          companyId: val,
          companyName: selected.hospitalName || "",
        };
      }
    },
    onAccurateProjectChange(val) {
      // 精准项目信息仅允许单选一级项目
      this.form.accurateProjectInfo = val ? [val] : [];
    },
    showTag(groupId, tag) {
      const { labelName } = this.form;
      if (!labelName) return;

      const isSelected = labelName.find(
        ({ labelGroupId, labelName }) =>
          labelGroupId === groupId && labelName === tag,
      );

      return isSelected ? "success" : undefined;
    },
    async getTags(val) {
      const response = await api.manage.getTagsByQaTypeId({
        qaTypeId: val,
      });
      this.tagOptions = response.data.data;
    },
    handleClick: throttle(function (group, tag, type) {
      const labelName = this.form.labelName;
      const groupId = group.id;
      const tagName = tag;

      if (type === "RADIO") {
        for (let i = labelName.length - 1; i >= 0; i--) {
          if (labelName[i].labelGroupId === groupId) {
            labelName.splice(i, 1);
          }
        }
        labelName.push({
          labelGroupId: groupId,
          labelName: tagName,
          type: "RADIO",
        });
      } else {
        let foundIndex = -1;
        for (let i = 0; i < labelName.length; i++) {
          const item = labelName[i];
          if (item.labelName === tagName && item.labelGroupId === groupId) {
            foundIndex = i;
            break;
          }
        }

        if (foundIndex !== -1) {
          labelName.splice(foundIndex, 1);
        } else {
          labelName.push({
            labelGroupId: groupId,
            labelName: tagName,
            type: type,
          });
        }
      }

      this.$refs.workOrder.validateField("labelName");
    }, 500),

    handerCustomer(e) {
      this.form.tagCustomer = e;
      if (this.form.tagRadio && this.form.tagCustomer) {
        this.form.labelName = "1";
        this.$refs.workOrder.validateField("labelName");
      }
    },
    handerRadio(e, type) {
      this.form.tagRadio = e;
      if (this.form.tagRadio && this.form.tagCustomer) {
        this.form.labelName = "1";
        this.$refs.workOrder.validateField("labelName");
      }
    },
    showLabel(name) {
      return this.templateEnum.filter((item) => item.moduleName === name)[0]
        .label;
    },
    showPropRule(name) {
      return this.propRuleEnum[name];
    },
    checkPropRule(item) {
      let rule = [];
      switch (item.moduleName) {
        case "WORK_ORDER_TOPIC":
        case "WORK_ORDER_DESCRIBE":
        case "RELATION_WORK_ORDER":
          rule = [
            {
              required: item.isRequired,
              message: "请填写",
              trigger: ["blur", "change"],
            },
          ];
          break;
        case "IMAGE_UPLOAD":
        case "ATTACHMENTS_UPLOAD":
        case "CUSTOMER_INFO":
        case "ATTENTION_USER":
          rule = [
            {
              required: item.isRequired,
              message: "请填写",
              type: "array",
              trigger: ["blur", "change"],
            },
          ];
          break;
        case "WEBSITE_INFO":
          rule = [
            {
              type: "object",
              required: item.isRequired,
              validator(rule, value, callback) {
                if (rule.required) {
                  if (value.websiteUrl || value.websiteName) {
                    callback();
                  } else {
                    callback("请至少输入一个网站信息");
                  }
                } else {
                  callback();
                }
              },
              trigger: ["blur", "change"],
            },
          ];
          break;
        case "COMPANY_MODEL":
          rule = [
            {
              type: "object",
              required: item.isRequired,
              validator(rule, value, callback) {
                if (rule.required) {
                  if (value.companyInfo) {
                    callback();
                  } else {
                    callback("请填写相关机构");
                  }
                } else {
                  callback();
                }
              },
              trigger: ["blur", "change"],
            },
          ];
          break;
        case "MONEY_MODEL":
          rule = [
            {
              required: item.isRequired,
              message: "请填写涉及金额",
              type: "number",
              trigger: ["blur", "change"],
            },
          ];
          break;
        case "LABEL_MODEL":
          rule = [
            {
              required: item.isRequired,
              message: "请选择标签",
              type: "array",
              trigger: ["blur", "change"],
            },
          ];
          break;
        case "DOCTOR_INFO":
          rule = [
            {
              type: "object",
              required: item.isRequired,
              validator(rule, value, callback) {
                if (rule.required) {
                  if (value.doctorName || value.practiceCertificate) {
                    callback();
                  } else {
                    callback("请至少输入一个医生信息");
                  }
                } else {
                  callback();
                }
              },
              trigger: ["blur", "change"],
            },
          ];
          break;
        case "REGIONAL":
          rule = [
            {
              required: item.isRequired,
              message: "请选择地区",
              trigger: ["change"],
              validator: (rule, value, callback) =>
                this.regionalValidator(rule, value, callback),
            },
          ];
          break;
        case "ACCURATE_PROJECT_INFO":
          rule = [
            {
              required: item.isRequired,
              message: "请选择关联项目信息",
              type: "array",
              trigger: ["blur", "change"],
            },
          ];
          break;
        case "ACCURATE_CUSTOMER_INFO":
          rule = [
            {
              required: item.isRequired,
              message: "请输入用户ID或手机号",
              validator: (rule, value, callback) =>
                this.accurateCustomerInfoValidator(rule, value, callback),
            },
          ];
          break;
        case "ACCURATE_COMPANY_MODEL":
          rule = [
            {
              required: item.isRequired,
              message: "请选择机构名称",
              validator: (rule, value, callback) =>
                this.accurateCompanyInfoValidator(rule, value, callback),
            },
          ];
          break;
        case "BUSINESS_TYPE":
          rule = [
            {
              required: item.isRequired,
              message: "请选择业务类型",
              trigger: ["change"],
            },
          ];
          break;
      }
      return rule;
    },
    checkIsNum(str) {
      return /^\d+$/.test(str);
    },
    remoteMethod: throttle(function (query) {
      if (!this.checkIsNum(query)) {
        return;
      }
      if (query) {
        this.getRelationWorkOrder({
          wkOrderId: query,
        });
      } else {
        this.relationWorkOrderOptions = [];
      }
    }, 500),
    async getRelationWorkOrder(filters) {
      const response = await api.work.getRelationWorkOrder(filters);
      this.relationWorkOrderOptions = response.data.data;
    },
    addUserInfo() {
      this.form.customerInfoList.push({
        businessId: "",
        customerId: "",
        customerPhone: "",
        remark: "",
      });
    },
    deleteUser(index) {
      this.form.customerInfoList.splice(index, 1);
    },
    checkMutiId(arr) {
      arr = arr.filter((x) => x != "");
      return new Set(arr).size !== arr.length;
    },

    clearEmpty() {
      this.form.relationWorkOrderIds = this.form.relationWorkOrderIds.filter(
        (x) => x != "",
      );
    },
    checkRelationIdRequired() {
      let relationRule = this.qaTypeTemplateOptions.filter(
        (x) => x.moduleName == "RELATION_WORK_ORDER",
      );
      if (relationRule && relationRule.length > 0) {
        return relationRule[0].isRequired;
      } else {
        return false;
      }
    },
    checkRelationIdEmpty() {
      for (const element of this.form.relationWorkOrderIds) {
        if (element !== "") {
          return false;
        }
      }
      return true;
    },
    deleteRelationId(index) {
      this.form.relationWorkOrderIds.splice(index, 1);
    },
    relationWorkOrderIdsChange(val) {
      if (this.form.relationWorkOrderIds.filter((x) => x == val).length > 1) {
        this.$message.warning("不能选择相同的工单");
      }
    },
    peoplesValidator(rule, value, callback) {
      if (!value || value.length === 0) {
        callback(new Error("请选择审批人"));
        return;
      }
      callback();
    },
    regionalValidator(rule, value, callback) {
      if (rule.required) {
        if (!this.regionalSelectValue) {
          callback(new Error("请选择地区"));
          return;
        }
      }
      callback();
    },
    accurateCustomerInfoValidator(rule, value, callback) {
      if (rule.required) {
        if (
          !this.form.accurateCustomerInfo.customerId &&
          !this.form.accurateCustomerInfo.customerPhone
        ) {
          callback(new Error("请输入用户ID或手机号"));
          return;
        }
      }
      callback();
    },
    accurateCompanyInfoValidator(rule, value, callback) {
      if (rule.required) {
        if (!this.accurateCompanyInfoSelectValue) {
          callback(new Error("请选择机构"));
          return;
        }
      }
      callback();
    },
    onFollowPeoplesChange(val) {
      if (val.length == 0) {
        this.form.needNotifyFollowPeople = false;
      }
    },
    convertDynamicAcceptor(val) {
      if (val == "REGIONAL_BUSINESS_BUSINESS_MANAGER")
        return "区域业务商务负责人";
      if (val == "COMPANY_BUSINESS_MANAGER") return "机构商务负责人";
      if (val == "CUSTOMER_CONSULTING") return "客户所属咨询";
      if (val == "CUSTOMER_CONSULTING_SUPERVISOR") return "客户所属咨询主管";
      return val;
    },
    getNodeKey(node) {
      return node?.areaId || node?.id;
    },
    findNodePath(tree, targetId, path = []) {
      if (!Array.isArray(tree) || !targetId) return null;
      for (let node of tree) {
        const currentPath = [...path, node];
        if (this.getNodeKey(node) === targetId) {
          return currentPath;
        }
        if (node.children && node.children.length > 0) {
          const found = this.findNodePath(node.children, targetId, currentPath);
          if (found) return found;
        }
      }
      return null;
    },
    regionalChange(val) {
      if (!val || !this.areaTree || this.areaTree.length === 0) {
        this.form.regional = {
          regional: "",
          province: "",
          city: "",
        };
        return;
      }
      const path = this.findNodePath(this.areaTree, val);
      if (path && path.length === 3) {
        this.form.regional = {
          regional: path[0].id,
          province: path[1].id,
          city: path[2].id,
        };
      } else {
        this.form.regional = {
          regional: "",
          province: "",
          city: "",
        };
      }
    },
  },
};
